import { render, staticRenderFns } from "./SuggestionSelect.vue?vue&type=template&id=03a2f9a2"
import script from "../controllers/SuggestionSelect.ts?vue&type=script&lang=ts&external"
export * from "../controllers/SuggestionSelect.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports